<template>
  <b-alert :show="show" :variant="variant">
    <ul v-if="errorList.length > 1" class="error-list">
      <li v-for="(error, index) in errorList" :key="index">{{ getErrorMessage(error) }}</li>
    </ul>
    <p v-else-if="errorList.length > 0" class="mb-0">{{ getErrorMessage(errorList[0]) }}</p>
  </b-alert>
</template>

<script>
import _isEmpty from 'lodash/isEmpty'

export default {
  name: 'FormError',
  props: {
    errors: { type: [Array, String], default: null },
    variant: { type: String, default: 'danger' }
  },
  computed: {
    show() {
      return !_isEmpty(this.errors)
    },
    errorList() {
      if (!this.errors) return []
      return Array.isArray(this.errors) ? this.errors : [this.errors]
    }
  },
  methods: {
    getErrorMessage(error) {
      if (typeof error === 'string') return error
      return error?.title
    }
  }
}
</script>

<style lang="scss" scoped>
.error-list {
  margin: 0;
  padding-left: 22px;
}
</style>
